<template>
  <div class="comContent">
    <div class="header">
      <div>详情</div>
      <div class="flex-start">
        <el-button size="small" type="plain" style="margin-left: 8px" @click="back()">返回</el-button>
      </div>
    </div>

    <el-form ref="editForm" label-width="120px" :model="infoDetail" style="width: 100%" size="small">
      <div class="mb20 detail-title">
        <el-row style="width: 100%">
          <el-col :span="12">
            <div class="left_topic">基本信息</div>
          </el-col>
          <el-col :span="12" class="edit-rt">
            <el-button size="small" type="primary" @click="edit(1)">编辑</el-button>
            <el-button size="small" type="primary" @click="save(1)">保存</el-button>
          </el-col>
        </el-row>
      </div>
      <el-row class="flex-item mb-20">
        <div class="title">保证金</div>
        <div class="flex-item-rt">
          <!-- <div class="">￥</div> -->
          <div class="item">
            <el-input maxlength="9" onkeyup="value=value.replace(/^\D*(\d*(?:\.\d{0,2})?).*$/g, '$1')"
              v-model="infoDetail.payThreshold" :disabled="!isEdit" prefix-icon="rmb">
              <template slot="prefix">
                <span class="qty">￥</span>
                <!-- <svg-icon icon-class="rmb" style="font-size: 16px" /> -->
              </template>
            </el-input>
          </div>
          <div class="item tips">已缴金额＜保证金，商户登录系统时提交缴费</div>
        </div>
      </el-row>

      <el-row class="flex-item mb-20">
        <div class="title">停用阈值</div>
        <div class="flex-item-rt">
          <!-- <div class="">￥</div> -->
          <div class="item">
            <el-input maxlength="9" onkeyup="value=value.replace(/^\D*(\d*(?:\.\d{0,2})?).*$/g, '$1')"
              v-model="infoDetail.stopThreshold" :disabled="!isEdit" prefix-icon="rmb">
              <template slot="prefix">
                <span class="qty">￥</span>
                <!-- <svg-icon icon-class="rmb" style="font-size: 16px" /> -->
              </template>
            </el-input>
          </div>
          <div class="item tips">已缴金额＜停用，商户冻结</div>
        </div>
      </el-row>

      <el-row class="flex-item mb-20">
        <div class="title">订单占用金额</div>
        <div class="flex-item-rt">
          <!-- <div class="">￥</div> -->
          <div class="item">
            <el-input maxlength="9" onkeyup="value=value.replace(/^\D*(\d*(?:\.\d{0,2})?).*$/g, '$1')"
              v-model="infoDetail.lockAmount" :disabled="true" prefix-icon="rmb">
              <template slot="prefix">
                <span class="qty">￥</span>
                <!-- <svg-icon icon-class="rmb" style="font-size: 16px" /> -->
              </template>
            </el-input>
          </div>
          <div class="item tips" style="margin-top: -5px; line-height: 26px">
            线下打款时，订单会占用保证金，当订单金额＞未占用金额时，客户无法使用线下打款方式付款；
            <br />
            线下打款订单完结后，释放占用的保证金
          </div>
        </div>
      </el-row>

      <el-row class="flex-item mb-20">
        <div class="title">保证金余额</div>
        <div class="flex-item-rt">
          <!-- <div class="">￥</div> -->
          <div class="item">
            <el-input maxlength="9" onkeyup="value=value.replace(/^\D*(\d*(?:\.\d{0,2})?).*$/g, '$1')"
              v-model="infoDetail.useAmount" :disabled="true" prefix-icon="rmb">
              <template slot="prefix">
                <span class="qty">￥</span>
                <!-- <svg-icon icon-class="rmb" style="font-size: 16px" /> -->
              </template>
            </el-input>
          </div>
        </div>
      </el-row>

      <el-row class="flex-item mb-20">
        <div class="title">已缴金额</div>
        <div class="flex-item-rt">
          <div class="item">
            <el-input maxlength="9" onkeyup="value=value.replace(/^\D*(\d*(?:\.\d{0,2})?).*$/g, '$1')"
              v-model="infoDetail.oriAmount" :disabled="true" prefix-icon="rmb">
              <template slot="prefix">
                <span class="qty">￥</span>
              </template>
            </el-input>
          </div>
        </div>
      </el-row>

      <div class="mb20 detail-title">
        <el-row class="flex-item">
          <el-col :span="12" class="flex-item">
            <div class="left_topic">费率</div>
            <div style="margin-left: 20px">
              <span :style="infoDetail.beLineFee == 1 ? 'color:#cf1422' : 'color:#303133'
                ">线上收取费用</span>
              <el-switch v-model="infoDetail.beLineFee" :active-value="true" :inactive-value="false"
                :active-text="infoDetail.beLineFee ? '开启' : '关闭'" :inactive-text="''" active-color="#ff4949"
                inactive-color="#ccc" style="margin-left: 5px" :width="60" @change="setbeLineFee">
              </el-switch>
              <span style="margin-left: 20px; color: #8c8c8c">开启了线上收取费用，外部控销的商品仍线下收取费用</span>
            </div>
          </el-col>
          <el-col :span="12" class="edit-rt">
            <el-button size="small" type="primary" @click="setRateBatch(1)">批量设定费率</el-button>
          </el-col>
        </el-row>
      </div>

      <myTable :index="index" :selection="true" :page="page" :showpage="false" :operation="false" v-loading="loading"
        :table-data="tableData" :table-option.sync="tableOption" :expand="false"
        @handleSelectionChange="handleSelectionChange">
        <template slot="operation" slot-scope="scope">
          <div style="margin: 0 0px">
            <el-link type="primary" :underline="false" @click="setRate(scope.row, index)" style="margin-right: 10px">
              设定费率
            </el-link>
          </div>
        </template>
      </myTable>
      <div class="mb20 detail-title">
        <el-col>
          <div class="left_topic">康贝手续费</div>
        </el-col>
      </div>
      <el-col class="flex-item">
        <div class="title-tip" style="margin-right: 10px;">代收费率</div>
        <el-input v-model="invoiceFeeRate" placeholder="请输入" clearable style="width: 100px;" @input="handleInvoiceFeeRateChange">
        </el-input>
        <div style="color: #8c8c8c;margin-right: 10px;">%</div>
        <el-button size="small" type="primary" @click="setInvoiceFeeRate">保存</el-button>
      </el-col>
      <div>
        <el-col>
          <div class="left_topic" style="margin-top: 20px;">发票</div>
        </el-col>
      </div>
      <el-row class="flex-item">
        <div class="title-tip" style="margin-right: 10px;">开票类型</div>
        <el-checkbox-group v-model="invoiceType" :disabled="true">
          <el-checkbox v-for="(item, index) in invoicetypeData" :key="item.id" :label="item.id" :name="item.name">{{
            item.name
            || "" }}</el-checkbox>
        </el-checkbox-group>
      </el-row>

      <el-row class="flex-item">
        <div class="title-tip" style="margin-right: 10px;">送达时间</div>
        <el-radio-group v-model="serviceType" :disabled="true">
          <el-radio v-for="(item, index) in serviceData" :key="index" :label="item.id" :name="item.instructions">
            {{ item.instructions }}</el-radio>
        </el-radio-group>
      </el-row>
      <el-row :span="24" class="title-tip" v-if="serviceType == '1729306113932353538'">
        说明
      </el-row>
      <el-row :span="24" class="title-tip" v-if="serviceType == '1729306113932353538'">
        <el-input type="textarea" style="width: 500px" v-model="remark" maxlength="200"></el-input>
      </el-row>
    </el-form>

    <el-dialog title="设定费率" :visible.sync="visible" width="500px" :before-close="handleClose">
      <el-form :model="dialogForm" status-icon ref="dialogForm" label-width="160px" class="demo-ruleForm">
        <div class="dialog-body">
          <el-form-item label="费率（单位：百分比）">
            <el-input maxlength="6" onkeyup="value=value.replace(/^\D*(\d*(?:\.\d{0,2})?).*$/g, '$1')"
              v-model="dialogForm.scopeRate" size="small" clearable type="text" style="width: 290px"></el-input>
          </el-form-item>
        </div>
        <div class="flex-end">
          <el-button size="small" type="plain" style="margin-left: 8px" @click="handleClose()">返回</el-button>
          <el-button size="small" type="primary" style="margin-left: 8px" @click="submit(1)">确认</el-button>
        </div>
      </el-form>
    </el-dialog>
  </div>
</template>
<script>
import myTable from "@/components/myTable";
import { getinvoicetypeList } from "@/api/merchantsettlement/index";
import { shopLineFeePut, shopLineFeeGet ,updateMerchantNoRate,getShopDetail } from "@/api/shopmange/index";
import {
  updateShopRate,
  updateShopSecurityDeposit,
  queryShopManageDetails,
  cominvoiceproperty,
  getPlatformGuaranteeInfo,
  updateSetThreshold,
} from "@/api/businessManage";
export default {
  components: { myTable },
  props: {},
  data() {
    return {
      remarks: "",
      isEdit: false,
      visible: false,
      disabled: false,
      infoDetail: {
        overtimeDeliveryIndemnityRatio: "",
        overtimeDeliveryCompensationLimit: "",
        oriAmount: "",
        stopThreshold: "",
        useAmount: "",
        lockAmount: "",
        payThreshold: "",
        beLineFee: null,
      },
      loading: false,
      index: false,
      page: {
        total: 11,
        current: 1,
        size: 10,
        pageSizes: [10, 20, 30, 50],
      },
      dialogForm: {
        shopId: "",
        scopeId: "",
        scopeRate: "",
      },
      tableData: [],
      serviceType: "", // 送达时间
      serviceData: [
        {
          id: "1",
          name: "随货",
        },
        {
          id: "2",
          name: "月开",
        },
        {
          id: "3",
          name: "其他",
        },
      ],
      invoiceType: [], // 发票类型
      invoicetypeData: [
        {
          id: "1",
          name: "普通发票（纸质）",
        },
        {
          id: "2",
          name: "普通发票（电子）",
        },
        {
          id: "3",
          name: "增值税专用发票（纸质）",
        },
        {
          id: "4",
          name: "增值税专用发票（电子）",
        },
      ],
      chooseList: [], // 选择的经营范围
      tableOption: [
        { label: "商品经营范围", prop: "scopeName" },
        { label: "费率（单位：百分比）", prop: "scopeRate" },
        {
          label: "操作",
          prop: "operation",
          slot: true,
          // fixed: "right",
        },
      ],
      isSetRateBatch: false, // 是否是批量设置
      invoiceFeeRate: 0, // 发票手续费率
    };
  },
  filters: {},
  created() { },
  mounted() {
    this.cominvoiceproperty(); // 查询店铺开票设置信息
    this.getDetail();
    this.getBeLineFee();
    this.requestShopDetail();
  },
  methods: {
    // 设定费率
    setInvoiceFeeRate() {
      if (!this.invoiceFeeRate) {
        this.$message.warning("请输入发票手续费率!");
        return;
      }
      // 如果最后一位是 . 则添加 0
      if (this.invoiceFeeRate.slice(-1) === ".") {
        this.invoiceFeeRate += "0";
      }
      let params = {
        id: this.$route.query.id,
        merchantNoRate: this.invoiceFeeRate,
      };
      updateMerchantNoRate(params).then((res) => {
        this.$message.success("设定成功，已保存费率!");
      });
    },  
    // 发票手续费率改变时触发
    handleInvoiceFeeRateChange(e) {
      // 允许 0-100 保留2位小数
      this.invoiceFeeRate = e.replace(/^\D*(\d*(?:\.\d{0,2})?).*$/g, '$1');
    },
    // 线上收取费用 开启关闭
    setbeLineFee(e) {
      let params = {
        shopId: this.$route.query.id,
        beLineFee: e
      };
      shopLineFeePut(params).then((res) => {
        this.$message.success("开关切换成功，已保存开关状态!");
      });
    },

    // 查询线上收取费用 开启关闭状态
    getBeLineFee() {
      let params = {
        shopId: this.$route.query.id,
      };
      shopLineFeeGet(params).then((res) => {
        if (res) {
          this.infoDetail.beLineFee = true;
        } else {
          this.infoDetail.beLineFee = false;
        }
      });
    },
    // 查询商户详情
    requestShopDetail() {
      getShopDetail(this.$route.query.id).then((res) => {
        const {merchantNoRate = 0} = res.data || {}
        this.invoiceFeeRate = merchantNoRate;
      });
    },
    cominvoiceproperty() {
      let params = { shopId: this.$route.query.id };
      cominvoiceproperty(params).then((res) => {
        this.serviceData = res.data.allIndicator;
        let invoiceType = res.data.invoiceType;
        if (invoiceType) {
          this.invoiceType = invoiceType.split(",");
        }
        this.serviceType = res.data.deliveryWay;
        this.remarks = res.data.remark;
      });
    },
    checkNumberValue(inputObj) {
      console.log(inputObj);
      if (!/(^0$)|(^100$)|(^\d{1,2}$)/.test(inputObj)) {
        if (inputObj.value > 100) {
          inputObj.value = 100;
        }
        if (inputObj.value < 0) {
          inputObj.value = 0;
        }
      } else {
        this.$message.warning("输入格式有误！");
      }
    },
    getDetail() {
      queryShopManageDetails({
        shopId: this.$route.query.id,
      }).then((res) => {
        console.log(res);
        // this.infoDetail = res.data;
        this.tableData = res.data.shopReteVO;

        this.$forceUpdate();
      });
      // getPlatformGuaranteeInfo 文志凯新接口
      getPlatformGuaranteeInfo({
        shopId: this.$route.query.id,
      }).then((res) => {
        this.infoDetail.id = res.id;

        // 保证金
        this.$set(
          this.infoDetail,
          "oriAmount",
          res.oriAmount ? parseFloat(res.oriAmount).toFixed(2) : "0.00"
        );
        // 订单占用金额
        this.$set(
          this.infoDetail,
          "lockAmount",
          res.lockAmount ? parseFloat(res.lockAmount).toFixed(2) : "0.00"
        );
        // 停用阈值
        this.$set(
          this.infoDetail,
          "stopThreshold",
          res.stopThreshold ? parseFloat(res.stopThreshold).toFixed(2) : "0.00"
        );
        // 保证金余额
        this.$set(
          this.infoDetail,
          "useAmount",
          res.useAmount ? parseFloat(res.useAmount).toFixed(2) : "0.00"
        );

        // 保证金 缴费阈值
        this.$set(
          this.infoDetail,
          "payThreshold",
          res.payThreshold ? parseFloat(res.payThreshold).toFixed(2) : "0.00"
        );

        // 保证金 缴费阈值
        this.$set(
          this.infoDetail,
          "overtimeDeliveryIndemnityRatio",
          res.overtimeDeliveryIndemnityRatio
            ? parseFloat(res.overtimeDeliveryIndemnityRatio).toFixed(2)
            : 0
        );

        // 保证金 缴费阈值
        this.$set(
          this.infoDetail,
          "overtimeDeliveryCompensationLimit",
          res.overtimeDeliveryCompensationLimit
            ? parseFloat(res.overtimeDeliveryCompensationLimit).toFixed(2)
            : "0.00"
        );

        this.$forceUpdate();
      });

      // console.log(this.infoDetail)
    },

    // 設定費率 弹窗
    setRate(row, index) {
      // console.log(row, "----row");
      this.visible = true;
      this.dialogForm.shopId = row.shopId;
      this.dialogForm.scopeId = row.scopeId;
      this.dialogForm.scopeRate = "";
      this.isSetRateBatch = false;
      // console.log(this.chooseList);
    },
    // 批量设置费率 弹窗
    setRateBatch(type) {
      if (this.chooseList.length == 0) {
        this.$message.warning("请先选择商品经营范围！");
      } else {
        this.visible = true;
        this.isSetRateBatch = true;
      }
    },
    handleClose() {
      this.visible = false;
      this.dialogForm.scopeRate = "";
    },
    submit() {
      var params = [];
      if (!this.dialogForm.scopeRate) {
        this.$message.warning("请先设置费率！");
        return;
      } else {
        if (parseFloat(this.dialogForm.scopeRate) > 100) {
          this.$message.warning("费率不能大于100！");
        }
        // 是否 批量设置 费率
        if (this.isSetRateBatch) {
          for (let i = 0; i < this.chooseList.length; i++) {
            this.chooseList[i].scopeRate = this.dialogForm.scopeRate;
          }
          this.submitRate(this.chooseList);
        } else {
          params = [
            {
              shopId: this.dialogForm.shopId,
              scopeId: this.dialogForm.scopeId,
              scopeRate: this.dialogForm.scopeRate,
            },
          ];
          console.log(params);
          this.submitRate(params);
        }
      }
    },

    submitRate(params) {
      updateShopRate(params).then((res) => {
        console.log(res);
        if (res.code == 0) {
          this.visible = false;
          this.getDetail();
        } else {
          this.$message.warning(res.msg);
        }
      });
    },

    edit() {
      this.isEdit = !this.isEdit;
    },

    save() {
      if (!this.isEdit) {
        this.$message.warning("请先编辑！");
        return;
      }
      if (!this.infoDetail.payThreshold) {
        this.$message.warning("请先设置商户保证金！");
        return;
      }
      if (!this.infoDetail.stopThreshold) {
        this.$message.warning("请先设置停用阈值！");
        return;
      }

      let params = {
        id: this.infoDetail.id,
        shopId: this.$route.query.id,
        payThreshold: parseFloat(this.infoDetail.payThreshold),
        stopThreshold: parseFloat(this.infoDetail.stopThreshold),
      };
      // updateSetThreshold 文志凯新接口
      updateSetThreshold(params).then((res) => {
        console.log(res);
        if (res) {
          this.$message.success("提交成功");
          this.isEdit = false;
          this.getDetail();
        } else {
          this.$message.error("提交失败");
        }
      });
      // console.log(this.infoDetail, "infoDetail");
    },
    // 选择经营范围
    handleSelectionChange(e) {
      this.chooseList = e;
      console.log(e);
    },
    back() {
      this.$router.push("./businessManage-shop-index");
      window.sessionStorage.removeItem("shop-detail");
    },
  },
};
</script>
<style lang="scss" scoped>
@import url("./styles/index.scss");
</style>
